import { Text } from "../../../../components/common/typography";
import type { SaleDetailsDto } from "../../../../api";

function FinStat({ label, value, className }: { label: string; value: string; className?: string }) {
  return (
    <div className="flex flex-col gap-0.5 px-6 py-4 max-md:px-4 max-md:py-3">
      <Text variant="bodySm" tone="muted">{label}</Text>
      <Text variant="bodyBold" tone="inherit" className={className ?? "text-textDark"}>{value}</Text>
    </div>
  );
}

function Divider() {
  return <div className="w-px self-stretch bg-borderLight max-md:hidden" />;
}

export function FinancialBar({ order }: { order: SaleDetailsDto }) {
  // TODO: expose margin rate, supplier payout, payout status, payment gateway from backend
  const margin = Math.round(order.amountTotal * 0.07);
  const supplierPayout = order.amountTotal - margin;

  return (
    // Phones: a two-column grid of stats instead of one long row.
    <div className="flex items-stretch rounded-2xl border border-borderDefault bg-bgWhite max-md:grid max-md:grid-cols-2 max-md:py-1">
      <FinStat
        label="Buyer Paid"
        value={`QAR ${order.amountTotal.toLocaleString()}`}
        className="text-accentGreenDark"
      />
      <Divider />
      <FinStat
        label="Procurtal Margin (7%)"
        value={`QAR ${margin.toLocaleString()}`}
        className="text-accentGreenDark"
      />
      <Divider />
      <FinStat
        label="Supplier Payout"
        value={`QAR ${supplierPayout.toLocaleString()}`}
      />
      <Divider />
      <FinStat
        label="Payout Status"
        value="Pending Validation"
        className="text-accentError"
      />
      <Divider />
      <FinStat label="Payment Gateway" value="Tap Payments" />
    </div>
  );
}
